var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-box"},[_c('el-tabs',{attrs:{"type":"card"}},[_c('el-tab-pane',{attrs:{"label":_vm.title,"name":"first"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }